import { Component, OnInit, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService, TiposCreditos } from '../../../../services/tools/helpers.service';
import { ReportesColocadosService } from '../../../../services/reportes/reportes-colocados.service';

@Component({
    selector: 'colocados-estacionarios',
    templateUrl: './colocados-estacionarios.component.html'
  })

export class ColocadosEstacionariosComponent implements OnInit {
    @Output() public onAfterLoad : EventEmitter<void> = new EventEmitter;

    public reportData: any [] = [];
    public totales: any = {};

    constructor(
        private helperService: HelpersService,
        private reportesService: ReportesColocadosService
    ){
    }

    public ngOnInit() {
    }

    public updateReporte(filters: any){

        this.reportesService.reporteTipoCredito(TiposCreditos.Estacionario, filters).subscribe(
        (response)=>
        {
            const jsonResult = response.json();
            let items = [];
            let totales = {};
            if(jsonResult.content ){
                if(jsonResult.content.items){
                    items = jsonResult.content.items;
                }
                if(jsonResult.content.totales){
                    totales = jsonResult.content.totales;
                }
            }

            this.reportData = items;
            this.totales = totales;
            this.onAfterLoad.emit();
        }, error =>
        {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/creditos-colocados/components/estacionarios/colocados-estacionarios.component.ts